import Vue from 'vue'
import { BootstrapVue, IconsPlugin} from 'bootstrap-vue'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '/style/themes/style.min.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)